import { LinkProps } from "react-router-dom";

import { HoverableLink } from "./styles";

export const LinkComponent: React.FC<LinkProps> = props => {
  return <HoverableLink {...props} />;
};
